import Vue from "vue";
import Vuex from "vuex";

import lunr from "lunr";

//import axios from "axios";
//import VueAxios from "vue-axios";

Vue.use(Vuex);

const removeFromArray = (array, value) => {
  const newArray = [...array];
  const index = newArray.indexOf(value);
  if (index > -1) {
    newArray.splice(index, 1);
    return newArray;
  }
  return array;
};

const removeTagFromArray = (array, value) => {
  const newArray = [...array];

  let index = newArray.findIndex(function (post, key) {
    if (post.term_id == value[1] && post.type_name == value[0]) return true;
  });

  if (index > -1) {
    newArray.splice(index, 1);
    return newArray;
  }

  return array;
};

export default new Vuex.Store({
  state: {
    events: window.lp_event_hub_data.events,
    taxonomies: Object.values(window.lp_event_hub_data.taxonomies),
    locations: Object.values(window.lp_event_hub_data.locations),
    tags_list: window.lp_event_hub_data.tags_list,
    posts_per_page: window.lp_event_hub_data.posts_per_page,
    stylesheet_directory: window.lp_event_hub_data.stylesheet_directory,
    i18n: window.lp_event_hub_data.i18n,
    posts: null,
    wp_total: 0,
    wp_totalpages: 0,
    post_types: [],
    tags: [],
    filterTags: [],
    currentPage: 1,
    searchInput: "",
    isLoading: true,
    additionnalPage: false,
    searchIndex: null,
    current_location: null,
    currentMonth: { value: "upcoming" },
    monthList: [],
  },

  mutations: {
    UPDATE_MONTH_LIST(state, value) {
      state.monthList = value;
    },

    UPDATE_LOCATION(state, value) {
      state.current_location = value;
    },

    UPDATE_MONTH(state, value) {
      state.currentMonth = value;
    },

    UPDATE_SEARCH(state, value) {
      state.searchInput = value;
    },

    UPDATE_SEARCH_INDEX(state, value) {
      state.searchIndex = value;
    },

    ADD_TAXONOMY(state, payload) {
      state.taxonomies[payload[0]].active.push(payload[1]);

      const termsList = state.taxonomies[payload[0]].terms;

      let name = "";

      for (const property in termsList) {
        if (termsList[property].term_id == payload[1]) {
          name = termsList[property].name;
        }
      }

      state.filterTags.push({
        type: "taxonomy",
        type_name: payload[0],
        term_id: payload[1],
        name: name,
      });
    },

    ADD_TAG(state, payload) {
      state.tags.push(payload[1]);

      state.filterTags.push({
        type: "tag",
        type_name: "tag",
        term_id: payload[1],
        name: payload[0],
      });
    },

    REMOVE_TAG(state, payload) {
      const newArray = removeFromArray(state.tags, payload);
      state.tags = newArray;

      const newFilterTags = removeTagFromArray(state.filterTags, [
        "tag",
        payload,
      ]);
      state.filterTags = newFilterTags;
    },

    REMOVE_TAXONOMY(state, payload) {
      const newArray = removeFromArray(
        state.taxonomies[payload[0]].active,
        payload[1]
      );
      state.taxonomies[payload[0]].active = newArray;

      const newFilterTags = removeTagFromArray(state.filterTags, payload);
      state.filterTags = newFilterTags;
    },
    REMOVE_ALL_TAXONOMY(state, payload) {
      state.taxonomies[payload].active = [];

      let newFilterTags = state.filterTags.filter(function (tag) {
        return tag.type_name != payload;
      });

      state.filterTags = newFilterTags;
    },
  },

  actions: {
    buildIndex({ state, commit }) {
      const documents = state.events;

      let searchIndex = lunr(function () {
        this.ref("ID");
        this.field("post_content");
        this.field("post_title");

        documents.forEach((doc) => {
          this.add(doc);
        });
      });

      commit("UPDATE_SEARCH_INDEX", Object.freeze(searchIndex));
    },

    newRequest({ state, getters, commit }) {
      let months = [];

      let hasUpcoming = false;

      getters.filteredEvents.forEach((element) => {
        if (!element.isUpcoming) {
          let alreadyExists = false;

          alreadyExists = months.some(function (month) {
            return month.value == element.month_classement;
          });

          if (!alreadyExists) {
            months.push({
              name: element.month_name,
              value: element.month_classement,
            });
          }
        } else {
          hasUpcoming = true;
        }
      });

      months.sort((a, b) => a.value - b.value)

      if (hasUpcoming) months.push(getters.getInitalMonth);

      let reverseMonths = months.reverse();

      commit("UPDATE_MONTH_LIST", reverseMonths);


      const currentMonthExists = reverseMonths.some(function (month) {
        if (state.currentMonth) {
          return month.value == state.currentMonth.value;
        } else {
          return false;
        }
      });

      if (!currentMonthExists) {
        commit("UPDATE_MONTH", state.monthList[0]);
      } else {
        const currentMonth = state.monthList.find(month => month.value === state.currentMonth.value)
        commit("UPDATE_MONTH", currentMonth);
      }
    },
  },

  getters: {
    filteredEvents: (state) => {
      let filteredEvents = state.events;

      // On filtre les TAGS

      if (state.filterTags.length > 0) {
        const newFilteredEvents = filteredEvents.filter(function (event) {
          const retour = state.filterTags.some(function (tag) {
            return !event.tags.includes(tag.term_id);
          });

          return !retour;
        });

        filteredEvents = newFilteredEvents;
      }

      // On filtre la recherche

      if (state.searchInput != "") {
        const results = state.searchIndex.search(state.searchInput);

        const results_column = Array.from(results, (x) => parseInt(x.ref));

        const newFilteredEvents = filteredEvents.filter(function (event) {
          return results_column.includes(event.ID);
        });

        filteredEvents = newFilteredEvents;
      }

      // On filtre les locations

      if (state.current_location) {
        const newFilteredEvents = filteredEvents.filter(function (event) {
          return event.locations.includes(state.current_location);
        });

        filteredEvents = newFilteredEvents;
      }

      return filteredEvents;
    },

    eventsList: (state, getters) => {
      let filteredEvents = getters.filteredEvents;

      let month_classement;

      let countDifferentMonths = 0;

      // On filtre les dates

      if (state.currentMonth.value && state.currentMonth.value == "upcoming") {
        const newFilteredEvents = filteredEvents.filter(function (event) {
          return event.isUpcoming;
        });

        filteredEvents = newFilteredEvents;
      } else {
        const newFilteredEvents = filteredEvents.filter(function (event) {
          return event.month_classement == state.currentMonth.value;
        });

        filteredEvents = newFilteredEvents;
      }

      filteredEvents.sort(function (a, b) {
        return a.real_date_event - b.real_date_event;
      });

      // On ajoute les dates lorsqu'il y a plusieurs mois

      filteredEvents.forEach((element) => {
        if (element.month_classement != month_classement)
          countDifferentMonths++;

        month_classement = element.month_classement;
      });

      if (month_classement > 1) {
        let month_classement = "";

        let newFilteredEvents = [];

        filteredEvents.forEach((element) => {
          if (element.month_classement != month_classement) {
            newFilteredEvents.push({
              post_type: "title",
              title: element.month_name,
              id: "title-" + element.month_classement,
            });

            month_classement = element.month_classement;
          }

          newFilteredEvents.push(element);
        });

        filteredEvents = newFilteredEvents;
      }

      return filteredEvents;
    },

    getMonthList: (state, getters) => {
      let monthList = [];

      let month_classement;

      getters.filteredEvents.forEach((element) => {
        if (!element.isUpcoming) {
          if (element.month_classement != month_classement) {
            monthList.push({
              value: element.month_classement,
              label: element.month_name,
            });

            month_classement = element.month_classement;
          }
        }
      });

      monthList.push({
        value: state.i18n.upcoming_events,
        label: "upcoming",
      });

      return monthList.reverse();
    },

    getTagsList: (state) => {
      const tagsList = state.tags_list.filter(function (tag) {
        const retour = state.events.some(function (event) {
          return event.tags.includes(tag.term_id);
        });

        return retour;
      });

      return tagsList;
    },

    getTagByTermID: (state) => (term_id) => {
      const result = state.tags_list.filter((tag) => tag.term_id == term_id);

      return result;
    },

    getLocations: (state) => {
      let locations = state.locations;

      locations.unshift({
        name: '<i class="fal fa-video icone"></i>' + state.i18n.online_event,
        term_id: "online",
      });

      return state.locations;
    },

    getInitalMonth: (state) => {
      return {
        name: state.i18n.upcoming_events,
        value: "upcoming",
      };
    },

    getCurrentPositionInMonth: (state) => {
      if (state.monthList.length > 0) {
        let index = state.monthList
          .map((el) => el.value)
          .indexOf(state.currentMonth.value);

        return index;
      } else {
        return 0;
      }
    },
  },
});
